import { render } from "./OwnerSelect.vue?vue&type=template&id=122d5a6e&scoped=true"
import script from "./OwnerSelect.vue?vue&type=script&lang=js"
export * from "./OwnerSelect.vue?vue&type=script&lang=js"

import "./OwnerSelect.vue?vue&type=style&index=0&id=122d5a6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122d5a6e"]])

export default __exports__